import { doctorApi } from './doctorApi';
import { doctorHelpers } from './doctorHelpers';

export const doctorService = {
  ...doctorApi,
  ...doctorHelpers,
};

export * from './types';
